/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type FormFieldTypeEnum = "array" | "boolean" | "boolean_switch" | "container" | "container_image_slug" | "date" | "datetime" | "doc_slug" | "file_slug" | "image_slug" | "linked_contacts" | "multi_select" | "number" | "parent_shipment" | "port" | "rate_card" | "rich_text" | "searchable" | "shipment_image_slug" | "shipping_line" | "string" | "vessel" | "voyage" | "%future added value";
export type SettingTypeEnum = "config_settings" | "customs_types" | "default_folders" | "document_templates" | "document_types" | "email_templates" | "languages" | "miscellaneous_settings" | "ports" | "rate_cards" | "roles" | "shipment_types" | "shipping_lines" | "templates" | "%future added value";
export type EditSettingDialogQueryVariables = {
    type: SettingTypeEnum;
    slug: string;
};
export type EditSettingDialogQueryResponse = {
    readonly infoUpdateSettingForm: {
        readonly formSchema: {
            readonly fieldSet: ReadonlyArray<{
                readonly name: string;
                readonly type: FormFieldTypeEnum;
                readonly required: boolean;
                readonly title: string | null;
                readonly description: string | null;
                readonly format: string | null;
                readonly enum: ReadonlyArray<string | null> | null;
                readonly enumTitles: ReadonlyArray<string | null> | null;
                readonly disabled: boolean;
            }>;
        };
        readonly initialValue: {
            readonly " $fragmentRefs": FragmentRefs<"EditSettingDialog_settingUnion">;
        } | null;
    };
};
export type EditSettingDialogQuery = {
    readonly response: EditSettingDialogQueryResponse;
    readonly variables: EditSettingDialogQueryVariables;
};



/*
query EditSettingDialogQuery(
  $type: SettingTypeEnum!
  $slug: String!
) {
  infoUpdateSettingForm(type: $type, slug: $slug) {
    formSchema {
      fieldSet {
        name
        type
        required
        title
        description
        format
        enum
        enumTitles
        disabled
      }
    }
    initialValue {
      __typename
      ...EditSettingDialog_settingUnion
    }
  }
}

fragment EditSettingDialog_settingUnion on SettingsUnion {
  __isSettingsUnion: __typename
  ... on RoleSetting {
    name
    forContainers
    forShipments
  }
  ... on PortSetting {
    code
    name
    category
  }
  ... on LanguageSetting {
    code
    name
  }
  ... on ShippingLineSetting {
    name
    primaryEmails
    secondaryEmails
  }
  ... on DocumentTemplateSetting {
    docType
    title
    html
    category
  }
  ... on EmailTemplateSetting {
    title
    defaultRecipientRoles
    subjectPl
    subjectDe
    subjectEn
    subjectUa
    bodyPl
    bodyDe
    bodyEn
    bodyUa
    emailSignature
  }
  ... on TemplateSetting {
    title
    defaultRecipientRoles
    subjectPl
    subjectDe
    subjectEn
    subjectUa
    bodyPl
    bodyDe
    bodyEn
    bodyUa
    messageSignature
  }
  ... on DefaultFolderSetting {
    name
    folderType
  }
  ... on DocumentTypeSetting {
    title
    documentName
    oldDocumentName
    description
    category
  }
  ... on CustomsTypeSetting {
    name
    category
  }
  ... on MiscellaneousSettingSetting {
    label
    value
    description
  }
  ... on ConfigSettingSetting {
    label
    apply
    description
    category
    emailTemplateName
    emailTemplateSlug
  }
  ... on ShipmentTypeSetting {
    code
    portHandlingCharge
    vatChargePercent
    dutiesRatePercent
  }
  ... on RateCardSetting {
    name
    defaultCleaning
    standardCustomsClearance
    fiscalCustomsClearance
    transitCustomsClearance
    physicalCustomsReview
    forklift
    specialHandling
    twoPackCarDischarge
    threePackCarDischarge
    fourPackCarDischarge
    roroCarDischarge
    motorcycleDischarge
    freeWarehousingDays
    costWarehousing
    xRay
    storage
    cleaning
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "slug"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "type"
},
v2 = [
  {
    "kind": "Variable",
    "name": "slug",
    "variableName": "slug"
  },
  {
    "kind": "Variable",
    "name": "type",
    "variableName": "type"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "concreteType": "FormSchema",
  "kind": "LinkedField",
  "name": "formSchema",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "FormField",
      "kind": "LinkedField",
      "name": "fieldSet",
      "plural": true,
      "selections": [
        (v3/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "type",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "required",
          "storageKey": null
        },
        (v4/*: any*/),
        (v5/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "format",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "enum",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "enumTitles",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "disabled",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "code",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "category",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "defaultRecipientRoles",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "subjectPl",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "subjectDe",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "subjectEn",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "subjectUa",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "bodyPl",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "bodyDe",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "bodyEn",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "bodyUa",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "label",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "EditSettingDialogQuery",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "InfoUpdateSettingFormResponse",
        "kind": "LinkedField",
        "name": "infoUpdateSettingForm",
        "plural": false,
        "selections": [
          (v6/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "initialValue",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "EditSettingDialog_settingUnion"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "ApplicationQuery",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "EditSettingDialogQuery",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "InfoUpdateSettingFormResponse",
        "kind": "LinkedField",
        "name": "infoUpdateSettingForm",
        "plural": false,
        "selections": [
          (v6/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "initialValue",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              {
                "kind": "TypeDiscriminator",
                "abstractKey": "__isSettingsUnion"
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "forContainers",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "forShipments",
                    "storageKey": null
                  }
                ],
                "type": "RoleSetting",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  (v7/*: any*/),
                  (v3/*: any*/),
                  (v8/*: any*/)
                ],
                "type": "PortSetting",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  (v7/*: any*/),
                  (v3/*: any*/)
                ],
                "type": "LanguageSetting",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "primaryEmails",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "secondaryEmails",
                    "storageKey": null
                  }
                ],
                "type": "ShippingLineSetting",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "docType",
                    "storageKey": null
                  },
                  (v4/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "html",
                    "storageKey": null
                  },
                  (v8/*: any*/)
                ],
                "type": "DocumentTemplateSetting",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  (v4/*: any*/),
                  (v9/*: any*/),
                  (v10/*: any*/),
                  (v11/*: any*/),
                  (v12/*: any*/),
                  (v13/*: any*/),
                  (v14/*: any*/),
                  (v15/*: any*/),
                  (v16/*: any*/),
                  (v17/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "emailSignature",
                    "storageKey": null
                  }
                ],
                "type": "EmailTemplateSetting",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  (v4/*: any*/),
                  (v9/*: any*/),
                  (v10/*: any*/),
                  (v11/*: any*/),
                  (v12/*: any*/),
                  (v13/*: any*/),
                  (v14/*: any*/),
                  (v15/*: any*/),
                  (v16/*: any*/),
                  (v17/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "messageSignature",
                    "storageKey": null
                  }
                ],
                "type": "TemplateSetting",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "folderType",
                    "storageKey": null
                  }
                ],
                "type": "DefaultFolderSetting",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  (v4/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "documentName",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "oldDocumentName",
                    "storageKey": null
                  },
                  (v5/*: any*/),
                  (v8/*: any*/)
                ],
                "type": "DocumentTypeSetting",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  (v3/*: any*/),
                  (v8/*: any*/)
                ],
                "type": "CustomsTypeSetting",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  (v18/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "value",
                    "storageKey": null
                  },
                  (v5/*: any*/)
                ],
                "type": "MiscellaneousSettingSetting",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  (v18/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "apply",
                    "storageKey": null
                  },
                  (v5/*: any*/),
                  (v8/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "emailTemplateName",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "emailTemplateSlug",
                    "storageKey": null
                  }
                ],
                "type": "ConfigSettingSetting",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  (v7/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "portHandlingCharge",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "vatChargePercent",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "dutiesRatePercent",
                    "storageKey": null
                  }
                ],
                "type": "ShipmentTypeSetting",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "defaultCleaning",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "standardCustomsClearance",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "fiscalCustomsClearance",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "transitCustomsClearance",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "physicalCustomsReview",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "forklift",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "specialHandling",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "twoPackCarDischarge",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "threePackCarDischarge",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "fourPackCarDischarge",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "roroCarDischarge",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "motorcycleDischarge",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "freeWarehousingDays",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "costWarehousing",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "xRay",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "storage",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "cleaning",
                    "storageKey": null
                  }
                ],
                "type": "RateCardSetting",
                "abstractKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "1e57ca61ae84f7606248324e7346ee13",
    "id": null,
    "metadata": {},
    "name": "EditSettingDialogQuery",
    "operationKind": "query",
    "text": "query EditSettingDialogQuery(\n  $type: SettingTypeEnum!\n  $slug: String!\n) {\n  infoUpdateSettingForm(type: $type, slug: $slug) {\n    formSchema {\n      fieldSet {\n        name\n        type\n        required\n        title\n        description\n        format\n        enum\n        enumTitles\n        disabled\n      }\n    }\n    initialValue {\n      __typename\n      ...EditSettingDialog_settingUnion\n    }\n  }\n}\n\nfragment EditSettingDialog_settingUnion on SettingsUnion {\n  __isSettingsUnion: __typename\n  ... on RoleSetting {\n    name\n    forContainers\n    forShipments\n  }\n  ... on PortSetting {\n    code\n    name\n    category\n  }\n  ... on LanguageSetting {\n    code\n    name\n  }\n  ... on ShippingLineSetting {\n    name\n    primaryEmails\n    secondaryEmails\n  }\n  ... on DocumentTemplateSetting {\n    docType\n    title\n    html\n    category\n  }\n  ... on EmailTemplateSetting {\n    title\n    defaultRecipientRoles\n    subjectPl\n    subjectDe\n    subjectEn\n    subjectUa\n    bodyPl\n    bodyDe\n    bodyEn\n    bodyUa\n    emailSignature\n  }\n  ... on TemplateSetting {\n    title\n    defaultRecipientRoles\n    subjectPl\n    subjectDe\n    subjectEn\n    subjectUa\n    bodyPl\n    bodyDe\n    bodyEn\n    bodyUa\n    messageSignature\n  }\n  ... on DefaultFolderSetting {\n    name\n    folderType\n  }\n  ... on DocumentTypeSetting {\n    title\n    documentName\n    oldDocumentName\n    description\n    category\n  }\n  ... on CustomsTypeSetting {\n    name\n    category\n  }\n  ... on MiscellaneousSettingSetting {\n    label\n    value\n    description\n  }\n  ... on ConfigSettingSetting {\n    label\n    apply\n    description\n    category\n    emailTemplateName\n    emailTemplateSlug\n  }\n  ... on ShipmentTypeSetting {\n    code\n    portHandlingCharge\n    vatChargePercent\n    dutiesRatePercent\n  }\n  ... on RateCardSetting {\n    name\n    defaultCleaning\n    standardCustomsClearance\n    fiscalCustomsClearance\n    transitCustomsClearance\n    physicalCustomsReview\n    forklift\n    specialHandling\n    twoPackCarDischarge\n    threePackCarDischarge\n    fourPackCarDischarge\n    roroCarDischarge\n    motorcycleDischarge\n    freeWarehousingDays\n    costWarehousing\n    xRay\n    storage\n    cleaning\n  }\n}\n"
  }
};
})();
(node as any).hash = '8e3c942c5e60fb4da1d0d2922a7ec1be';
export default node;
